import { ResponseOptions } from '@/features/progresses/progresses.types';

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function sortOptionsByTitle(arr: ResponseOptions[] | undefined): ResponseOptions[] | undefined {
  if (!arr) return undefined;

  return arr.sort((a, b) => {
    if (!a.title || !b.title) return 0;
    return a.title > b.title ? 1 : -1;
  });
}

export const getGreetingMessage = (firstName: string) => {
  let message = '';
  const hours = new Date().getHours();
  if (hours < 12) message = 'Good morning';
  else if (hours < 18) message = 'Good afternoon';
  else message = 'Good evening';
  return message + ', ' + firstName;
};
